export default "__VITE_ASSET__Dm3K0MMj__"